<template>
  <div class="titlebar-container">
    <div class="titlebar-inputs">
      <div class="inputs-wrapper">
        <div class="saved-state">
          <span
            class="badge float-right"
            :class="{ saved: badgeText === 'saved' }"
            v-show="showBadge"
          >
            {{ badgeText }}
          </span>
        </div>
        <div class="partition" id="partition-register">
          <div class="partition-form">
            <form
              class=""
              autocomplete="false"
              ref="addProductForm"
              @submit.prevent="submitNewCapsule"
            >
              <dl class="input-item title-wrapper">
                <dt class="dt-text">Title</dt>
                <dd class="dd-text mt-2">
                  <div class="custom-form-elements">
                    <div class="input-group input-group-icon">
                      <b-form-input
                        id="capsule-title"
                        :state="validCapsuleTitleState"
                        v-model="title"
                        type="text"
                        placeholder="Title"
                        @blur="finishedEditing()"
                        debounce="500"
                      />
                      <div class="input-icon">
                        <i class="fi flaticon-015-pincushion"></i>
                      </div>
                      <b-form-invalid-feedback :state="validCapsuleTitleState">
                        Must be 5 characters or more
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </dd>
              </dl>

              <dl class="input-item occasion-wrapper">
                <dt class="dt-text">Occasion</dt>
                <dd class="dd-text mt-2">
                  <div class="custom-form-elements">
                    <div class="input-group input-group-icon">
                      <b-form-input
                        id="capsule-occasion"
                        :state="validCapsuleOccasionState"
                        v-model="occasion"
                        type="text"
                        placeholder="Occasion"
                        @blur="finishedEditing()"
                        debounce="500"
                      />
                      <div class="input-icon"><i class="pe-7s-coffee"></i></div>
                      <b-form-invalid-feedback
                        :state="validCapsuleOccasionState"
                      >
                        Must be 5 characters or more
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </dd>
              </dl>

              <dl class="input-item notes-wrapper">
                <dt class="dt-text">Style notes</dt>
                <dd class="dd-text mt-2">
                  <div class="custom-form-elements">
                    <div class="input-group input-group-icon">
                      <b-form-textarea
                        id="textarea"
                        v-model="notes"
                        :state="validCapsuleNotesState"
                        rows="3"
                        max-rows="6"
                        placeholder="Add style notes..."
                        @blur="finishedEditing()"
                        debounce="500"
                      />
                      <b-form-invalid-feedback :state="validCapsuleNotesState">
                        Can't be longer than 1000 characters
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </dd>
              </dl>

              <dl class="input-item occasion-wrapper">
                <dt class="dt-text">Link</dt>
                <dd class="dd-text mt-2">
                  <div class="custom-form-elements">
                    <div class="input-group input-group-icon">
                      <b-form-input
                        id="capsule-occasion"
                        :state="validCapsuleLinkState"
                        v-model="link"
                        type="url"
                        placeholder="URL to your blog or article"
                        @blur="finishedEditing()"
                        debounce="500"
                      />
                      <div class="input-icon"><i class="pe-7s-link"></i></div>
                      <b-form-invalid-feedback :state="validCapsuleLinkState">
                        Not a valid URL
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                </dd>
              </dl>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="titlebar-actions">
      <b-button
        size="lg"
        variant="unstitched"
        class="publish-capsule-btn mb-3 pr-5 pl-5"
        :disabled="!capsulePublishable || haveValuesChanged"
        @click="showPublishModal"
        v-if="!isCapsulePublished"
      >
        Publish
      </b-button>

      <span
        class="requirements-text"
        v-b-popover.hover.left.html="popoverText"
        title="Publish Requirements"
        variant="unstitched"
        v-if="!isCapsulePublished"
      >
        requirements
        <i class="pe-7s-info" aria-hidden="true"></i>
      </span>
    </div>
  </div>
</template>

<script>
import MiscUtils from "@/utils/MiscUtils";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      showBadge: false,
      badgeText: "unsaved",
      title: "",
      occasion: "",
      notes: "",
      link: "",
      popoverText: `
        Minimum 2 per group

        <ul class="mr-4">
          <li class="mt-2"><b>Shirts & T-shirts</b></li>
          <li><b>Shorts & Trousers</b></li>
          <li><b>Footwear</b></li>
        </ul>`,
    };
  },

  created() {
    this.validateURL = MiscUtils.validateURL;
  },

  mounted() {
    if (this.currentCapsule) this.populateLocalData();
  },

  methods: {
    ...mapActions(["updateCapsule"]),

    populateLocalData() {
      this.title = this.currentCapsule.title;
      this.occasion = this.currentCapsule.occasion;
      this.notes = this.currentCapsule.notes;
      this.link = this.currentCapsule.link;
    },

    finishedEditing() {
      this.trimWhiteSpaces();
      if (this.validDetailsForUnpublished || this.validDetailsForPublished)
        this.saveChanges();
    },

    trimWhiteSpaces() {
      this.title = this.title ? this.title.trim() : this.title;
      this.occasion = this.occasion ? this.occasion.trim() : this.occasion;
      this.notes = this.notes ? this.notes.trim() : this.notes;
      this.link = this.link ? this.link.trim() : this.link;
    },

    saveChanges() {
      const payload = {
        capsuleId: this.currentCapsule.id,
        title: this.title,
        occasion: this.occasion,
        notes: this.notes,
        link: this.link,
      };

      this.updateCapsule(payload).then(() => {
        if (!!!this.updateCapsuleError) {
          this.badgeText = "saved";
          setTimeout(() => (this.showBadge = false), 1500);
        }
      });
    },

    checkChanges(fieldName) {
      if (this.currentCapsule[fieldName] === null) {
        return !!this.currentCapsule[fieldName] !== !!this[fieldName];
      } else {
        return this.currentCapsule[fieldName] !== this[fieldName];
      }
    },

    showPublishModal() {
      this.$nextTick(() => {
        this.$modal.show("confirm-publish-capsule", {
          capsuleId: this.currentCapsule.id,
        });
      });
    },
  },

  computed: {
    ...mapGetters(["currentUser", "currentCapsule", "updateCapsuleError"]),

    capsulePublishable() {
      return this.currentCapsule.publishable;
    },

    isCapsulePublished() {
      return this.currentCapsule.status === "published";
    },

    validDetailsForUnpublished() {
      return this.haveValuesChanged && !this.isCapsulePublished;
    },

    validDetailsForPublished() {
      return (
        this.haveValuesChanged &&
        this.isCapsulePublished &&
        this.validCapsuleTitleState &&
        this.validCapsuleOccasionState
      );
    },

    validCapsuleTitleState() {
      return this.title ? this.title.length >= 5 : false;
    },

    validCapsuleOccasionState() {
      return this.occasion ? this.occasion.length >= 5 : false;
    },

    validCapsuleNotesState() {
      return !this.notes ? null : this.notes.length <= 1000;
    },

    validCapsuleLinkState() {
      return !this.link ? null : this.validateURL(this.link);
    },

    haveValuesChanged() {
      return !!(
        this.checkChanges("title") ||
        this.checkChanges("occasion") ||
        this.checkChanges("notes") ||
        this.checkChanges("link")
      );
    },
  },

  watch: {
    currentCapsule: function () {
      this.populateLocalData();
    },

    haveValuesChanged: function (newVal) {
      if (newVal) {
        this.badgeText = "unsaved";
        this.showBadge = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_custom_form.scss";

.titlebar-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 50px;

  @include for-tablet-portrait-up {
    flex-direction: row;
  }
}

// START: Titlebar Inputs
.titlebar-inputs {
  display: flex;
  height: 90%;
  border-top: 1px solid $primary-accent;
  box-shadow: 0px 2px 6px 0px hsla(0, 0%, 0%, 0.2);
  padding: 0;
  background-color: $grey6;

  @include for-tablet-portrait-up {
    width: 60%;
  }

  @include for-tablet-landscape-up {
    padding: 15px;
    flex: 1;
  }

  .inputs-wrapper {
    .saved-state {
      min-height: 1.1rem;

      .badge {
        background-color: $alizarin;
        color: white;
        font-weight: 500;
        text-transform: capitalize;

        &.saved {
          background-color: $emerald;
        }
      }
    }
    width: 100%;
    padding: 15px;
    padding-top: 0px;

    @include for-tablet-landscape-up {
      display: flex;
      align-items: stretch;
      flex-wrap: wrap;
      flex: 4;
      flex-direction: column;

      .title-wrapper,
      .occasion-wrapper {
        flex: 1 0 50%;
      }

      .notes-wrapper {
        flex: 1 0 100%;
      }
    }
  }
}
// END

// START: Titlebar Inputs > Input Item
.input-item {
  font-size: 0.9rem;

  &:not(:last-child) {
    margin-bottom: 30px;
  }

  .dt-text {
    font-size: 1rem;
    font-weight: 300;
    color: #929cad;
  }

  .dd-text {
    font-weight: 300;

    @include for-phone-only {
      padding: 0;
    }
  }

  .dd-input {
    width: 100%;
    border: none;
    border-bottom: 1px solid white;
    background: #fff;
    resize: none;
    font-weight: 300;

    &::placeholder {
      font-style: oblique;
    }

    &:active,
    &:focus,
    &:hover {
      border-bottom: 1px solid $primary-accent;
    }

    &:active,
    &:focus {
      padding-left: 10px;
    }

    &:hover {
      cursor: pointer;
    }

    @include for-desktop-up {
      max-width: 80%;
    }
  }
}
// End

// START: Titlebar Actions
.titlebar-actions {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;

  @include for-tablet-portrait-up {
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 0px;
    height: 90%;
    width: 40%;
  }

  @include for-tablet-landscape-up {
    width: 30%;
  }

  .publish-capsule-btn {
    border-radius: 0;
    padding: 15px;
    font-size: 11px;
    letter-spacing: 1.4px;

    &:hover {
      box-shadow: 0 8px 24px rgba($primary-blue, 0.25);
    }
  }

  .requirements-text {
    font-style: oblique;
    margin-bottom: 5px;
    font-size: 14px;
    color: $primary-blue;

    &:hover {
      cursor: help;
    }
  }
}
// END

.form-control {
  &::placeholder {
    font-style: italic;
    font-weight: 300;
  }
}

.custom-form-elements .form-control,
.custom-form-elements .form-control.is-valid,
.custom-form-elements .form-control.is-invalid {
  background-color: whitesmoke;
  &:focus {
    background-color: #fff;
  }
}

.custom-form-elements .input-group-icon .input-icon {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/TitleBar.vue